import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  row: {
    background: theme.custom.tableHeadColor,
  },
  cell: {
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    color: '#fff',
  },
  checkboxCell: {
    width: 48,
  },
}));
